import {sendRequest} from '@js/utils';

export default function initContactForm($wrapper = $('body')) {
    $wrapper
        .on('click', '.feedback-form__submit', function () {
            const $form = $(this).closest('.feedback-form');
            const data = $form.serialize();
            const $errorsContainer = $form.find('.feedback-form__errors');

            function handler(response) {
                if (response) {
                    if (typeof response.success !== 'undefined' && response.success) {
                        $errorsContainer.hide();
                        $form.html($('<p>', {class: 'alert'})
                            .text(response.message));
                    } else if (typeof response.errors !== 'undefined') {
                        $errorsContainer.html('');
                        const messages = [];
                        for (const field in response.errors) {
                            for (const index in response.errors[field]) {
                                messages.push(response.errors[field][index]);
                            }
                        }
                        if (messages) {
                            $errorsContainer.append(messages.join('<br>'));
                            $errorsContainer.show();
                        }
                    }
                }
            }

            sendRequest('post', '/contacts/createMessage', data, handler);
        });
}
